import * as C from '../../constants';
import defaultState from './defaultState';

export default {

  [C.SKI_PASS_RESET_STATE](state) {
    Object.assign(state, defaultState());
  },

  // region Seasons
  [C.SKI_PASS_SEASONS_LOAD_PENDING](state) {
    state.seasons = {
      ...state.seasons,
      itemsLoading: true,
      itemsError: undefined,
    };
  },

  [C.SKI_PASS_SEASONS_LOAD_FAILURE](state, payload) {
    state.seasons = {
      ...state.seasons,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_PASS_SEASONS_LOAD_SUCCESS](state, payload) {
    state.seasons = {
      ...state.seasons,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },
  // endregion

  // region Season
  [C.SKI_PASS_SEASON_LOAD_PENDING](state) {
    state.season = {
      ...state.season,
      itemsLoading: true,
      itemsError: undefined,
    };
  },

  [C.SKI_PASS_SEASON_LOAD_FAILURE](state, payload) {
    state.season = {
      ...state.season,
      ...payload,
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_PASS_SEASON_LOAD_SUCCESS](state, payload) {
    const payloadCopy = Object.assign({}, payload);
    const newSeasonItem = {
      ...state.season,
      ...Object.assign({}, state.season.newSeasonItem),
    };
    if (payloadCopy.discounts) {
      newSeasonItem.discounts.items = payloadCopy.discounts;
      delete payloadCopy.discounts;
    }
    if (payloadCopy.personCategories) {
      newSeasonItem.personCategories.items = payloadCopy.personCategories;
      delete payloadCopy.personCategories;
    }
    if (newSeasonItem.seasonAreas) {
      newSeasonItem.skiAreas.ids = Object.values(newSeasonItem.seasonAreas);
      delete newSeasonItem.seasonAreas;
    }
    const seasonItem = {
      ...newSeasonItem,
      ...payloadCopy,
    };
    state.season = {
      ...state.season,
      ...seasonItem,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_PASS_SEASON_CREATE_PENDING](state) {
    state.season = {
      ...state.season,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_SEASON_CREATE_SUCCESS](state, payload) {
    state.season = {
      ...state.season,
      ...payload,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_SEASON_CREATE_FAILURE](state, payload) {
    state.season = {
      ...state.season,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_PASS_SEASON_SAVE_PENDING](state) {
    state.season = {
      ...state.season,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_SEASON_SAVE_SUCCESS](state, payload) {
    state.season = {
      ...state.season,
      ...payload,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_SEASON_SAVE_FAILURE](state, payload) {
    state.season = {
      ...state.season,
      saveLoading: false,
      saveError: payload,
    };
  },
  // endregion

  [C.SKI_PASS_SEASON_PICK_UP_PLACES_PENDING](state) {
    state.pickupPlaces = {
      ...state.pickupPlaces,
      loading: true,
      error: false,
      items: [],
    };
  },

  [C.SKI_PASS_SEASON_PICK_UP_PLACES_SUCCESS](state, payload) {
    state.pickupPlaces = {
      ...state.pickupPlaces,
      loading: false,
      error: false,
      items: payload,
    };
  },

  [C.SKI_PASS_SEASON_PICK_UP_PLACES_FAILURE](state) {
    state.pickupPlaces = {
      ...state.pickupPlaces,
      loading: false,
      error: true,
      items: [],
    };
  },

  // region Suppliers
  [C.SKI_SUPPLIERS_LOAD_PENDING](state) {
    state.suppliers = {
      ...state.suppliers,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_SUPPLIERS_LOAD_SUCCESS](state, payload) {
    state.suppliers = {
      ...state.suppliers,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_SUPPLIERS_LOAD_FAILURE](state, payload) {
    state.suppliers = {
      ...state.suppliers,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_PASS_SEASON_SET](state, payload) {
    state.season = {
      ...state.season,
      ...payload,
    };
  },
  // endregion

  // region Person Categories
  [C.SKI_PASS_PERSON_CATEGORIES_LOAD_PENDING](state) {
    state.season.personCategories = {
      ...state.season.personCategories,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_PASS_PERSON_CATEGORIES_LOAD_SUCCESS](state, payload) {
    state.season.personCategories = {
      ...state.season.personCategories,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_PASS_PERSON_CATEGORIES_LOAD_FAILURE](state, payload) {
    state.season.personCategories = {
      ...state.season.personCategories,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_PASS_PERSON_CATEGORY_ADD](state) {
    const newPersonCategory = Object.assign({}, state.season.personCategories.newItem);
    newPersonCategory.skiPassSeasonId = state.season.id;
    state.season.personCategories.items = [
      newPersonCategory,
      ...Object.values(state.season.personCategories.items),
    ];
  },

  [C.SKI_PASS_PERSON_CATEGORIES_SET](state, payload) {
    const personCategoryItem = {
      ...Object.assign({}, payload.personCategoryItem),
      ...payload.params,
    };
    const items = Object.values(state.season.personCategories.items).map(
      personCategory => (
        personCategory.id === personCategoryItem.id ? personCategoryItem : personCategory
      ),
    );
    state.season.personCategories.items = items;
  },

  [C.SKI_PASS_PERSON_CATEGORY_CREATE_PENDING](state) {
    state.season.personCategories = {
      ...state.season.personCategories,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_PERSON_CATEGORY_CREATE_SUCCESS](state) {
    state.season.personCategories = {
      ...state.season.personCategories,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_PERSON_CATEGORY_CREATE_FAILURE](state, payload) {
    state.season.personCategories = {
      ...state.season.personCategories,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_PASS_PERSON_CATEGORY_SAVE_PENDING](state) {
    state.season.personCategories = {
      ...state.season.personCategories,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_PERSON_CATEGORY_SAVE_SUCCESS](state, payload) {
    const items = Object.values(state.season.personCategories.items)
      .map(personCategory => (personCategory.id === payload.id ? payload : personCategory));
    state.season.personCategories = {
      ...state.season.personCategories,
      items,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_PERSON_CATEGORY_SAVE_FAILURE](state, payload) {
    state.season.personCategories = {
      ...state.season.personCategories,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_PASS_PERSON_CATEGORY_REMOVE_PENDING](state) {
    state.season.personCategories = {
      ...state.season.personCategories,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_PERSON_CATEGORY_REMOVE_SUCCESS](state, payload) {
    const items = Object.values(state.season.personCategories.items)
      .filter(personCategory => personCategory.id !== payload);
    state.season.personCategories = {
      ...state.season.personCategories,
      items,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_PERSON_CATEGORY_REMOVE_FAILURE](state, payload) {
    state.season.personCategories = {
      ...state.season.personCategories,
      saveLoading: false,
      saveError: payload,
    };
  },
  // endregion

  // region Discounts
  [C.SKI_PASS_DISCOUNTS_LOAD_PENDING](state) {
    state.season.discounts = {
      ...state.season.discounts,
      items: [],
      itemsLoading: true,
      itemsError: undefined,
    };
  },

  [C.SKI_PASS_DISCOUNTS_LOAD_SUCCESS](state, payload) {
    state.season.discounts = {
      ...state.season.discounts,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_PASS_DISCOUNTS_LOAD_FAILURE](state, payload) {
    state.season.discounts = {
      ...state.season.discounts,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_PASS_DISCOUNT_ADD](state) {
    const newDiscount = Object.assign({}, state.season.discounts.newItem);
    newDiscount.skiPassSeasonId = state.season.id;
    state.season.discounts.items = [newDiscount, ...state.season.discounts.items];
  },

  [C.SKI_PASS_DISCOUNT_SET](state, payload) {
    let discountItem = Object.assign({}, payload.discountItem);
    discountItem = {
      ...discountItem,
      ...payload.params,
    };
    const items = Object.values(state.season.discounts.items)
      .map(
        discount => (discount.id === discountItem.id ? discountItem : discount),
      );
    state.season.discounts.items = {
      ...items,
    };
  },

  [C.SKI_PASS_DISCOUNT_CREATE_PENDING](state) {
    state.season.discounts = {
      ...state.season.discounts,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_DISCOUNT_CREATE_SUCCESS](state) {
    state.season.discounts = {
      ...state.season.discounts,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_DISCOUNT_CREATE_FAILURE](state, payload) {
    state.season.discounts = {
      ...state.season.discounts,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_PASS_DISCOUNT_SAVE_PENDING](state) {
    state.season.discounts = {
      ...state.season.discounts,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_DISCOUNT_SAVE_SUCCESS](state, payload) {
    const items = Object.values(state.season.discounts.items)
      .map(discount => (discount.id === payload.id ? payload : discount));
    state.season.discounts = {
      ...state.season.discounts,
      items,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_DISCOUNT_SAVE_FAILURE](state, payload) {
    state.season.discounts = {
      ...state.season.discounts,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_PASS_DISCOUNT_REMOVE_PENDING](state) {
    state.season.discounts = {
      ...state.season.discounts,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_DISCOUNT_REMOVE_SUCCESS](state, payload) {
    const items = Object.values(state.season.discounts.items)
      .filter(discount => discount.id !== payload);
    state.season.discounts = {
      ...state.season.discounts,
      items,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_DISCOUNT_REMOVE_FAILURE](state, payload) {
    state.season.discounts = {
      ...state.season.discounts,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_PASS_DISCOUNT_PERSON_CATEGORY_SAVE_PENDING](state) {
    state.season.discounts.personCategories = {
      ...state.season.discounts.personCategories,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_DISCOUNT_PERSON_CATEGORY_SAVE_SUCCESS](state, payload) {
    state.season.discounts.personCategories = {
      ...state.season.discounts.personCategories,
      items: payload,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_DISCOUNT_PERSON_CATEGORY_SAVE_FAILURE](state, payload) {
    state.season.discounts.personCategories = {
      ...state.season.discounts.personCategories,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_PASS_DISCOUNT_PERSON_CATEGORY_DELETE_PENDING](state) {
    state.season.discounts.personCategories = {
      ...state.season.discounts.personCategories,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_DISCOUNT_PERSON_CATEGORY_DELETE_SUCCESS](state, payload) {
    state.season.discounts.personCategories = {
      ...state.season.discounts.personCategories,
      items: payload,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_DISCOUNT_PERSON_CATEGORY_DELETE_FAILURE](state, payload) {
    state.season.discounts.personCategories = {
      ...state.season.discounts.personCategories,
      saveLoading: false,
      saveError: payload,
    };
  },
  // endregion

  // region Ski Pass Areas
  [C.SKI_PASS_AREAS_LOAD_PENDING](state) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_PASS_AREAS_LOAD_SUCCESS](state, payload) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_PASS_AREAS_LOAD_FAILURE](state, payload) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_PASS_AREAS_SAVE_PENDING](state) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_AREAS_SAVE_SUCCESS](state, payload) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      items: payload,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_AREAS_SAVE_FAILURE](state) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_AREAS_DELETE_PENDING](state) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_AREAS_DELETE_SUCCESS](state, payload) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      items: payload,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_AREAS_DELETE_FAILURE](state) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      saveLoading: false,
      saveError: undefined,
    };
  },
  // endregion

  // region Sales Types
  [C.SKI_PASS_SALES_TYPES_LOAD_PENDING](state) {
    state.salesTypes = {
      ...state.salesTypes,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_PASS_SALES_TYPES_LOAD_SUCCESS](state, payload) {
    state.salesTypes = {
      ...state.salesTypes,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_PASS_SALES_TYPES_LOAD_FAILURE](state, payload) {
    state.salesTypes = {
      ...state.salesTypes,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },
  // endregion

  // region Periods
  [C.SKI_PASS_PERIODS_LOAD_PENDING](state) {
    state.season.pricePeriods = {
      ...state.season.pricePeriods,
      itemsLoading: true,
      itemsError: undefined,
    };
  },

  [C.SKI_PASS_PERIODS_LOAD_SUCCESS](state, payload) {
    state.season.pricePeriods = {
      ...state.season.pricePeriods,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_PASS_PERIODS_LOAD_FAILURE](state, payload) {
    state.season.pricePeriods = {
      ...state.season.pricePeriods,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_PASS_PERIOD_ADD](state) {
    const newPeriodItem = Object.assign({}, state.season.pricePeriods.newPeriodItem);
    newPeriodItem.skiPassSeasonId = state.season.id;
    state.season.pricePeriods.items = [
      newPeriodItem,
      ...Object.values(state.season.pricePeriods.items),
    ];
  },

  [C.SKI_PASS_PERIOD_SET](state, payload) {
    state.season.pricePeriods.items = Object.values(state.season.pricePeriods.items)
      .map((period) => {
        if (period.id === payload.periodId) {
          return {
            ...Object.assign({}, period),
            ...payload.params,
          };
        }
        return period;
      });
  },

  [C.SKI_PASS_PERIOD_CREATE_PENDING](state) {
    state.season.pricePeriods = {
      ...state.season.pricePeriods,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_PERIOD_CREATE_SUCCESS](state) {
    state.season.pricePeriods = {
      ...state.season.pricePeriods,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_PERIOD_CREATE_FAILURE](state, payload) {
    state.season.pricePeriods = {
      ...state.season.pricePeriods,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_PASS_PERIOD_SAVE_PENDING](state) {
    state.season.pricePeriods = {
      ...state.season.pricePeriods,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_PERIOD_SAVE_SUCCESS](state, payload) {
    const items = Object.values(state.season.pricePeriods.items)
      .map((period) => {
        if (period.id === payload.id) {
          return {
            id: payload.id,
            skiPassSeasonId: payload.skiPassSeasonId,
            arrivalFrom: payload.arrivalFrom,
            arrivalTo: payload.arrivalTo,
            days: payload.days,
            prices: period.prices,
          };
        }
        return period;
      });
    state.season.pricePeriods = {
      ...state.season.pricePeriods,
      items,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_PERIOD_SAVE_FAILURE](state, payload) {
    state.season.pricePeriods = {
      ...state.season.pricePeriods,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_PASS_PERIOD_REMOVE_PENDING](state) {
    state.season.pricePeriods = {
      ...state.season.pricePeriods,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_PERIOD_REMOVE_SUCCESS](state, payload) {
    const items = Object.values(state.season.pricePeriods.items).filter(
      pricePeriod => pricePeriod.id !== payload,
    );
    state.season.pricePeriods = {
      ...state.season.pricePeriods,
      items,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_PERIOD_REMOVE_FAILURE](state, payload) {
    state.season.pricePeriods = {
      ...state.season.pricePeriods,
      saveLoading: false,
      saveError: payload,
    };
  },
  // endregion

  // region Prices
  [C.SKI_PASS_PERIOD_PRICE_LOAD_PENDING](state) {
    state.season.prices = {
      ...state.season.prices,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_PASS_PERIOD_PRICE_LOAD_SUCCESS](state, payload) {
    const periodId = Number(payload.periodId);
    const items = Object.values(state.season.pricePeriods.items).map((period) => {
      let prices = [];
      if (period.id === periodId) {
        prices = [
          ...Object.values(payload.prices).map(price => price),
        ];
      } else {
        prices = [...Object.values(period.prices)];
      }
      return {
        ...period,
        prices,
      };
    });
    state.season.pricePeriods.items = {
      ...items,
    };
    state.season.prices = {
      ...state.season.prices,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_PASS_PERIOD_PRICE_LOAD_FAILURE](state, payload) {
    state.season.prices = {
      ...state.season.prices,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_PASS_PERIOD_PRICE_SET](state, items) {
    state.season.pricePeriods.items = items;
  },

  [C.SKI_PASS_PERIOD_PRICE_ADD](state, items) {
    state.season.pricePeriods.items = items;
  },

  [C.SKI_PASS_PERIOD_PRICE_CREATE_PENDING](state) {
    state.season.prices = {
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_PERIOD_PRICE_CREATE_SUCCESS](state) {
    state.season.prices = {
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_PERIOD_PRICE_CREATE_FAILURE](state, payload) {
    state.season.prices = {
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_PASS_PERIOD_PRICE_SAVE_PENDING](state) {
    state.season.pricePeriods = {
      ...state.season.pricePeriods,
      saveLoading: true,
      saveError: undefined,
    };
    state.season.prices = {
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_PERIOD_PRICE_SAVE_SUCCESS](state) {
    state.season.pricePeriods = {
      ...state.season.pricePeriods,
      saveLoading: false,
      saveError: undefined,
    };
    state.season.prices = {
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_PERIOD_PRICE_SAVE_FAILURE](state, payload) {
    state.season.pricePeriods = {
      ...state.season.pricePeriods,
      saveLoading: false,
      saveError: payload,
    };
    state.season.prices = {
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_PASS_PERIOD_PRICE_REMOVE_PENDING](state) {
    state.season.pricePeriods = {
      ...state.season.pricePeriods,
      saveLoading: true,
      saveError: undefined,
    };
    state.season.prices = {
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_PERIOD_PRICE_REMOVE_SUCCESS](state, payload) {
    const items = Object.values(state.season.pricePeriods.items).map((period) => {
      const prices = [
        ...Object.values(period.prices).filter(price => price.id !== payload.priceId),
      ];
      return {
        ...period,
        prices,
      };
    });
    state.season.pricePeriods = {
      ...state.season.pricePeriods,
      items,
      saveLoading: false,
      saveError: undefined,
    };
    state.season.prices = {
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_PASS_PERIOD_PRICE_REMOVE_FAILURE](state, payload) {
    state.season.pricePeriods = {
      ...state.season.pricePeriods,
      saveLoading: false,
      saveError: payload,
    };
    state.season.prices = {
      saveLoading: false,
      saveError: payload,
    };
  },
  // endregion
};



// WEBPACK FOOTER //
// ./src/store/modules/ski/skipass/mutations.js